import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectAllocatedExpensesBudget(
    request: Boundaries["editProjectAllocatedExpensesBudget"]["request"],
  ): void;
}

function useEditProjectAllocatedExpensesBudget(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectAllocatedExpensesBudgetRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectAllocatedExpensesBudgetRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectAllocatedExpensesBudgetRequestFailure(project),
    ),
    editProjectAllocatedExpensesBudget: core.editProjectAllocatedExpensesBudget,
  };
}

export { useEditProjectAllocatedExpensesBudget };
